<div class="px-3">

    <div class="rem-text-default mb-6">
        <div class="flex align-items-center">
    
          <div class="rem-bg-light px-3 py-3 mr-2">
            <i class="pi pi-download font-medium text-xl"></i>
          </div>
          <div>
            <div class="text-2xl font-medium">ETL Ingestion Result</div>
            <div class="text-right mt-2">Browse etl ingeston results</div>
          </div>
          
        </div>
      </div>




    <div class="flex justify-content-between">
        <div class="flex flex-row gap-3">
            <p-calendar [(ngModel)]="fromDate" 
                        [readonlyInput]="true" 
                        placeholder="Process Start Date"
                        [maxDate]="toDate"
                        [minDate]="minDate"
                        >
            </p-calendar>
            <p-multiSelect [options]="creditors"
                           [(ngModel)]="selectedCreditors"
                           (ngModelChange)="onChangeCreditor($event)"
                           placeholder="Select Creditors"
                           optionLabel="CompanyName"
                           filterBy="CreditorId,CompanyName">
                <ng-template let-creditor pTemplate="item">
                    <div class="flex align-items-center justify-content-between flex-1">
                        <div>{{ creditor.CompanyName }}</div>
                        <div class="ml-2">{{ creditor.CreditorId }}</div>
                    </div>
                </ng-template>
            </p-multiSelect>
            <remitter-button
                (click)="search()" 
                label='Get'
                icon='search'
            >     
            </remitter-button>
        </div>
    </div>
    <div class="mt-4">
        <div *ngIf="!hasTableData && hasClickedSearch" style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                🚫 No records found for creditors.
        </div>

        <p-table 
            *ngIf="hasTableData"
            [value]="etlIngestionResults" 
            [paginator]="true"
            [rows]="5"
            [tableStyle]="{ 'min-width': '50rem' }"
            [rowsPerPageOptions]="[5, 10, 20]">

            <ng-template pTemplate="header">
                <tr class="text-xs">
                    <th>Creditor Id</th>
                    <th>Creditor Name</th>
                    <th>Process Start Time</th>
                    <th>Total Processed Record Count</th>
                    <th>Invoice Count</th>
                    <th>Contact Count</th>
                    <th>Voided Invoice Count</th>
                    <th>ETL Ids</th>
                    <th>Completion Message</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr class="text-xs">
                    <td>{{ product.CreditorId }}</td>
                    <td>{{ product.CreditorName }}</td>
                    <td>{{ product.ProcessStartTime }}</td>
                    <td>{{ product.TotalProcessedRecordCount }}</td>
                    <td>{{ product.InvoiceCount }}</td>
                    <td>{{ product.ContactCount }}</td>
                    <td>{{ product.VoidedInvoiceCount }}</td>
                    <td>{{ product.EtlIds}}</td>
                    <td>{{ product.CompletionMessage }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    

</div>